<template>
    <div class="table-responsive">
        <table v-if="(this.state === 'loaded' && attributes.length > 0 )" class="table">
            <thead>
                <tr>
                    <td><strong>Key</strong></td>
                    <td><strong>Value</strong></td>
                    <td><strong>Action</strong></td>
                </tr>
            </thead>
            <tbody>
                <tr :key="attribute.key" v-for="attribute in attributes">
                    <td>
                       {{ attribute.key }}
                    </td>
                    <td :style="{'word-break': 'break-word'}">
                        {{ attribute.value }}
                    </td>
                    <td class="c-table__cell center" >
                        <dropdown-actions :key="attribute.key+attribute.value" label="Actions"  >
                            <dropdown-action-item event="teamCustomAttribute.edit" :payload="attribute">Edit</dropdown-action-item>
                            <dropdown-action-item event="teamCustomAttribute.delete" :payload="attribute">Delete</dropdown-action-item>
                        </dropdown-actions>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="(this.state === 'loaded' && attributes.length < 1 )" data-test="no-attributes-msg">
            You don&apos;t have any attributes defined yet.  Add one using the form above.
        </div>
        <div v-if="(this.state === 'loading')" data-test="loading-msg">
            Loading attributes...
        </div>
    </div>
</template>

<script>
import { teamCustomAttributesClient } from '../../../services';
import DropdownActions from '../../general/DropDownActions.vue';
import DropdownActionItem from '../../general/DropDownActionItem.vue';

export default {
    props: ['user', 'team'],

    components: {
        DropdownActions,
        DropdownActionItem,
    },

    /**
     * The component's data.
     */
    data() {
        return {
            state: 'loading',
            attributes: [],
        };
    },

    /**
     * Prepare the component.
     */
    mounted() {
        this.getList();
    },

    created() {
        Bus.$on('teamCustomAttribute.created', () => {
            this.getList();
        });
        Bus.$on('teamCustomAttribute.delete', (attribute) => {
            this.deleteAttribute(attribute);
        });
        Bus.$on('teamCustomAttribute.deleted', () => {
            this.getList();
        });
        Bus.$on('teamCustomAttribute.updated', () => {
            this.getList();
        });
    },

    methods: {
        getList() {
            teamCustomAttributesClient
                .getAllCustomAttributes(this.team.id)
                .then((response) => {
                    let data = response.data.data.sort((a, b) => (a.key > b.key ? 1 : -1));
                    this.attributes = data;
                    this.state = 'loaded';
                })
                .catch((error) => {
                    this.state = 'error';
                    console.log(error);
                    this.$toasted.global.platform_error();
                });
        },
        deleteAttribute(attr) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Make sure to review your message templates after deleting this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'I am aware, delete the attribute!',
            }).then(({ value }) => {
                if (!value) return;

                teamCustomAttributesClient
                    .deleteCustomAttribute(this.team.id, attr.id)
                    .then(() => {
                        Bus.$emit('teamCustomAttribute.deleted');
                    })
                    .catch((error) => {
                        this.state = 'error';
                        console.log(error);
                        this.$toasted.global.platform_error();
                    });
            });
        },
    },
};
</script>
<style scoped>
.table-responsive {
    min-height: 150px;
}
</style>
